import { Link, useNavigate } from "react-router-dom";
import "./App.css";
import {
  ArrowCircleDownLeft,
  ArrowCircleUp,
  ArrowCircleUpRight,
  BoxArrowUp,
  ClockCounterClockwise,
  Repeat,
  ShieldSlash,
  Toolbox,
  VideoCamera,
  WarningCircle,
  Wrench,
} from "@phosphor-icons/react";
// import IsLoginFunc from "./libs/isLoginFunc.js";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import detectLocation from "./libs/detectLocation";
import { ReactComponent as Gambar } from "./assets/svg/hiking.svg";
import { ReactComponent as Gambarx } from "./assets/svg/tack.svg";
import CardLogisticsCrew from "./component/CardLogisticsCrew";
import { toast } from "sonner";
import axios from "axios";
import AddLogistics from "./component/AddLogistics";

const Logistics = () => {
  const [isVisible, setIsVisible] = useState(false)
  const routerPush = useNavigate()
  const handleHistory = () => {
    routerPush('/logistics/history')
  }
  const handleReport = () => {
    routerPush('/logistics/report')
  }
  const onClose = () => {
    setIsVisible(false)
  }
  const activeAddLogistic = () => {
    setIsVisible(true)
  }
  const [namaGweh, setNamaGweh] = useState(null);
  const [cookies] = useCookies(["token"]);
  const navigate = useNavigate();

  //! Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (
      !cookies.token ||
      cookies.token === null ||
      cookies.token === undefined
    ) {
      navigate("/login");
    } else {
      try {
        // Pastikan cookies.token adalah string dan valid
        const token = cookies.token;
        if (typeof token === "string" && token) {
          const userName = jwtDecode(token).email;
          setNamaGweh(userName);
        } else {
          navigate("/login");
        }
      } catch (error) {
        navigate("/login");
      }
    }
  }, [cookies.token, navigate]); // Menambahkan dependencies

  const today = new Date();
  const thisMonthLong = today.toLocaleDateString("en-GB", { month: "long" });


  const [data, setData] = useState([]);
  const [location, setLocation] = useState("Location not detected");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [keyword, setKeyword] = useState("");
  const [coords, setCoords] = useState("");
  const [id_user, setIdUser] = useState("");
  const [isAdmin, setIsAdmin ] = useState(false)

  const ocKeyword = (e) => {
    const { value } = e.target;
    setKeyword(value);
  };

  //! QUERY DATA
  useEffect(() => {
    const handleGweh = async () => {
      if (namaGweh !== null) {
        try {
          const api2 = `${process.env.REACT_APP_SERVER}/api/user/${namaGweh}`;
          const dataxcc = await axios.get(api2);
          const status = dataxcc.data.payload.datas.posisi === "Admin"
          setIsAdmin(status)
          setIdUser(dataxcc.data.payload.datas.id);
          const api = `${process.env.REACT_APP_SERVER}/api/logistics?id_user=${dataxcc.data.payload.datas.id}&keyword=${keyword}`;
          const dataxc = await axios.get(api);
          setData(dataxc.data);
        } catch (error) {
          setError(`An Error occured: ${error}`);
        } finally {
          setLoading(false);
        }
      }
    };
    handleGweh();

    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            // Perbaikan destructuring coords
            const { latitude, longitude } = position.coords;
            const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${Number(
              latitude
            )}&lon=${Number(longitude)}`;
            try {
              const response = await fetch(url);
              const data = await response.json();
              // Panggil fungsi detectLocation untuk memeriksa lokasi
              const isInLocation = detectLocation(latitude, longitude);

              // Tentukan lokasi pengguna berdasarkan hasil detectLocation
              const locationRightNow = isInLocation
                ? "In Dhoho TV"
                : data.name !== ""
                ? data.name
                : data.address.road !== undefined
                ? data.address.road +
                  ", " +
                  data.address.city_district +
                  ", " +
                  data.address.city
                : data.address.city_district +
                  ", " +
                  data.address.city +
                  ", " +
                  data.address.state;
              // Simpan lokasi ke state
              setLocation(locationRightNow);
              setCoords(latitude + ", " + longitude);
              console.warn(locationRightNow);
            } catch (error) {
              console.error("Error fetching data address:", error);
              setLocation("Location undefined"); // Set address ke null jika ada kesalahan
            }
          },
          (error) => {
            setLocation("Location not detected");
          }
        );
      } else {
        setError("Geolocation is not supported by this browser.");
      }
    };

    getLocation();

    return () => {};
  }, [namaGweh, keyword]);

  if (loading) {
    return (
      <div className="relative min-h-svh bg-slate-100 text-black">
        <div className="pt-6 px-4 pb-28 flex flex-col gap-10">
          {/* Status Features */}
          <div className="grid grid-cols-2 gap-4">
            <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <ArrowCircleDownLeft
                  size={40}
                  weight="fill"
                  className=" text-green-700"
                />
                <div>
                  <p className="font-semibold text-sm whitespace-nowrap text-black">
                    Ready
                  </p>
                  <p className="text-gray-400 font-medium text-xs">Early</p>
                </div>
              </div>
              <p className="font-bold text-black text-2xl">--</p>
            </div>
            <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <ArrowCircleUpRight
                  size={40}
                  weight="fill"
                  className=" text-green-700"
                />
                <div>
                  <p className="font-semibold text-sm whitespace-nowrap text-black">
                    Check Out
                  </p>
                  <p className="text-gray-400 font-medium text-xs">Early</p>
                </div>
              </div>
              <p className="font-bold text-black text-2xl">--</p>
            </div>
            <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <ArrowCircleUp
                  size={40}
                  weight="fill"
                  className=" text-green-700"
                />
                <div>
                  <p className="font-semibold text-sm text-black">Leave</p>
                  {/* Month */}
                  <p className="text-gray-400 font-medium text-xs">
                    {thisMonthLong}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <p className="font-bold text-black text-2xl">--</p>
                <span className="text-gray-400 font-semibold text-sm">Day</span>
              </div>
            </div>
            <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <div className="p-2 bg-green-700 rounded-full">
                  <Repeat size={17} weight="bold" className=" text-white" />
                </div>
                <div>
                  <p className="font-semibold text-sm whitespace-nowrap text-black">
                    Total Attended
                  </p>
                  {/* Month */}
                  <p className="text-gray-400 font-medium text-xs">
                    {thisMonthLong}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <p className="font-bold text-black text-2xl">--</p>
                <span className="text-gray-400 font-normal">Day</span>
              </div>
            </div>
          </div>
          {/* Attend History */}
          <div className="flex justify-between items-center">
            <p className="text-lg font-bold">Attendance History</p>
            <Link
              to={"/analytics"}
              className="font-semibold text-sm text-green-600 cursor-pointer"
            >
              See More
            </Link>
          </div>
          <div className="-mt-6 flex flex-col gap-3">
            <div className="p-2 rounded-lg shadow flex gap-6 bg-slate-50">
              <div className="px-6 py-2 justify-center items-center flex flex-col min-h-[5.25rem] skeleton min-w-[4.5rem] text-white  bg-gray-200 rounded-lg gap-3">
                <p className={"text-2xl font-bold opacity-0 "}>22</p>
                <p className="text-sm font-light opacity-0">22</p>
              </div>
              {/* BUILD TIME STATUS */}
              <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
                <div className="flex justify-evenly ">
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_in)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check In
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center ">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check Out
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {timeDifference(cb.check_in, cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Total Hours
                    </p>
                  </div>
                </div>
                <div className="flex  justify-center items-center">
                  <div className="gap-1.5 w-64 skeleton h-4 bg-gray-100"></div>
                </div>
              </div>
            </div>
            <div className="p-2 rounded-lg shadow flex gap-6 bg-slate-50">
              <div className="px-6 py-2 justify-center items-center flex flex-col min-h-[5.25rem] skeleton min-w-[4.5rem] text-white  bg-gray-200 rounded-lg gap-3">
                <p className={"text-2xl font-bold opacity-0 "}>22</p>
                <p className="text-sm font-light opacity-0">22</p>
              </div>
              {/* BUILD TIME STATUS */}
              <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
                <div className="flex justify-evenly ">
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_in)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check In
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center ">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check Out
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {timeDifference(cb.check_in, cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Total Hours
                    </p>
                  </div>
                </div>
                <div className="flex  justify-center items-center">
                  <div className="gap-1.5 w-64 skeleton h-4 bg-gray-100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (error) return <div>Error: {error}</div>;

  const datas = data.payload.datas;
  const allLogisticsCount = "Total Logistics: " + datas.allLogisticsCount;
  const readyLogisticsCount = datas.readyLogisticsCount;
  const useLogisticsCount = datas.useLogisticsCount;
  const maintenanceLogisticsCount = datas.maintenanceLogisticsCount;
  const brokenLogisticsCount = datas.brokenLogisticsCount;
  const dataLogisticsYouUse = datas.dataLogisticsYouUse;
  const dataLogistics = datas.dataLogistics;

  


  return (
    <div className="relative min-h-svh bg-slate-100 text-black">
      <div className="pt-6 px-4 pb-28 flex flex-col gap-5">
        {/* Greetings */}
        <div className="flex justify-between items-center gap-4">
          <div className=" rounded-full px-4 py-2 shadow  bg-green-700 border border-green-700 flex items-center justify-center gap-2">
            <p className="text-xs font-extralight text-white whitespace-nowrap">
              {allLogisticsCount}
            </p>
            <Toolbox weight="fill" color="white" size={16} />
          </div>
          <div onClick={handleReport} className="rounded-full px-4 py-2 shadow  bg-red-400 bg-opacity-25 border border-red-400 text-red-400 flex items-center justify-center gap-2">
            <WarningCircle weight="fill" size={16} />
            <p className="text-xs font-bold whitespace-nowrap">
              {"Report Logistics"}
            </p>
          </div>
        </div>
        {/* Status Features */}
        <div className="grid grid-cols-2 gap-4">
          <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <div className="p-2 bg-green-700 rounded-full">
                <BoxArrowUp size={17} weight="fill" className=" text-white" />
              </div>
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Ready
                </p>
                <p className="text-gray-400 font-medium text-xs">Count</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {readyLogisticsCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">Items</span>
            </div>
          </div>
          <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <div className="p-2 bg-orange-500  rounded-full">
                <VideoCamera size={17} weight="fill" className=" text-white" />
              </div>
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Use
                </p>
                <p className="text-gray-400 font-medium text-xs">Count</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {useLogisticsCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">Items</span>
            </div>
          </div>
          <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <div className="p-2 bg-amber-400 rounded-full">
                <Wrench size={17} weight="fill" className=" text-white" />
              </div>
              <div>
                <p className="font-semibold text-sm text-black">Maintenance</p>
                {/* Month */}
                <p className="text-gray-400 font-medium text-xs">Count</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {maintenanceLogisticsCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">Items</span>
            </div>
          </div>
          <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <div className="p-2 bg-red-700 rounded-full">
                <ShieldSlash size={17} weight="fill" className=" text-white" />
              </div>
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Broken
                </p>
                {/* Month */}
                <p className="text-gray-400 font-medium text-xs">{"Count"}</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {brokenLogisticsCount}
              </p>
              <span className="text-gray-400 font-normal">Items</span>
            </div>
          </div>
        </div>
        {/* Add Logistics */}
        {
          isAdmin && (
            <div className="flex justify-end items-center gap-4">
              <div onClick={activeAddLogistic} className=" cursor-pointer rounded-full px-6 py-2 shadow  bg-green-700 border border-green-700 flex items-center justify-center gap-2">
                <Toolbox weight="fill" color="white" size={16} />
                <p className="text-xs font-extralight text-white whitespace-nowrap">
                  Add Logistic
                </p>
              </div>
              <AddLogistics isVisible={isVisible} onClose={onClose} last_user_id={id_user} location_logistics_cords={coords} location_logistics_name={location} />
            </div>
          )
        }
        {/* Attend History */}

        <div className="flex gap-2  items-center">
          <label className="bg-slate-50 w-full flex-1 input input-bordered flex items-center gap-2">
            <input
              onChange={ocKeyword}
              type="text"
              className="grow"
              placeholder="Search"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-4 w-4 opacity-70"
            >
              <path
                fillRule="evenodd"
                d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                clipRule="evenodd"
              />
            </svg>
          </label>
          <button onClick={handleHistory} className="btn bg-slate-50 text-slate-600">
            <ClockCounterClockwise size={24} />
          </button>
        </div>
        {/* YOU USE */}
        {dataLogisticsYouUse.length > 0 && (
          <>
            <div className="flex justify-center items-center">
              <p className="flex-1 border-t h-1 w-full bg-gray-300 rounded"></p>
              <p className="text-lg text-gray-400 px-2">You Use</p>
              <p className="flex-1 border-t h-1 w-full bg-gray-300 rounded"></p>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {/* Card */}
              {dataLogisticsYouUse.map((cb, i) => {
                {
                  return (
                    <CardLogisticsCrew
                      cb={cb}
                      location={location}
                      coords={coords}
                      key={i}
                      id_user={id_user}
                    />
                  );
                }
              })}
            </div>
            <div className="flex justify-center items-center">
              <p className="flex-1 border-t h-1 w-full bg-gray-300 rounded"></p>
            </div>
          </>
        )}
        {/* YOU USE */}

        <div className="grid sm:grid-cols-2 gap-3">
          {/* Card */}
          {dataLogistics.map((cb, i) => {
            {
              return (
                <CardLogisticsCrew
                  cb={cb}
                  location={location}
                  coords={coords}
                  key={i}
                  id_user={id_user}
                />
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default Logistics;

export function getIndochinaTime(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    hour: "2-digit",
    minute: "2-digit",
  }); // Format HH:mm
}

export function timeDifference(date1, date2) {
  // Mengonversi parameter menjadi objek Date jika bukan sudah dalam bentuk Date
  const startTime = new Date(date1);
  const endTime = new Date(date2);

  // Menghitung selisih waktu dalam milidetik
  const differenceInMilliseconds = endTime - startTime;

  // Menghitung jam dan menit dari selisih waktu
  const totalMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Format menjadi HH:MM
  const formattedTimeDifference = `${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}`;

  return formattedTimeDifference;
}
